import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


var vUI_Event_Spend_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_EVTSTYPE_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Spend Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    SPENDTYPE_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Spend Type Id',    columnResourceName: 'colEventSpendTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SPEND_TYPE_NAME:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name',             columnResourceName: 'colEventSpendTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SOURCE_ID:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID',        columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    MAINTABGRID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Main Grid',        columnResourceName: 'colMainGrid', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    RATE_LEVEL:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Rate Level',       columnResourceName: 'colRateLevel', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    RATEBASIS_OPTIONS: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Rate Basis Opts',  columnResourceName: 'colRateBasis', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    RATEUOM_OPTIONS:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Rate UOM Opts',    columnResourceName: 'colRateUOM',   alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    ACTIVE_IND:   {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Active',    columnResourceName: 'colActInd',   alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1}}
}

var EventSpendTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_EVTSTYPE_ID',
                id_ui: 'SPENDTYPE_ID',
                name:  'SPEND_TYPE_NAME'},

    searchProviderFields: vUI_Event_Spend_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Event_Spend_Type_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var EventSpendTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "EventSpendTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'SPENDTYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'SPEND_TYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'SPENDTYPE_ID','SPEND_TYPE_NAME','SOURCE_ID', 'MAINTABGRID', 'RATE_LEVEL', 'RATEBASIS_OPTIONS', 'RATEUOM_OPTIONS', 'ACTIVE_IND', 
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: EventSpendTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var EventSpendTypeSearch: ISearch = {
    searchName: "Find Event Spend Type",
    renderOptions: { ui5ResourceId: "EventSpendTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [EventSpendTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("EventSpendTypeBO", "EventSpendType", EventSpendTypeSearch, "Customer Search")

export {EventSpendTypeSearch}